'use client';

import React, { createContext, useContext, useMemo, useState } from 'react';
import { INVENTORIES, TBondType } from '@/creditflowresearch/domain/BondType';

interface IBondsTileTabContext {
  activeTab: TBondType,
  setActiveTab: (tab: TBondType) => void,
}

const BondsTileTabContext = createContext<IBondsTileTabContext | null>(null);

export const useBondsTileTabContext = (): IBondsTileTabContext => {
  const context = useContext(BondsTileTabContext);
  if (!context) {
    throw new Error('useBondsTileTabContext must be used within BondsTileTabContextProvider');
  }
  return context;
};

const BondsTileTabContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeTab, setActiveTab] = useState<TBondType>(INVENTORIES);
  const value = useMemo(() => ({ activeTab, setActiveTab }), [activeTab]);

  return (
    <BondsTileTabContext.Provider value={ value }>
      { children }
    </BondsTileTabContext.Provider>
  );
};

export default BondsTileTabContextProvider;
